import React, { useState, useEffect, useContext } from 'react'
import InvoiceItemHeader from './InvoiceItemHeader'
import InvoiceItemInner from './InvoiceItemInner'
import InvoiceItemFooter from './InvoiceItemFooter'
import { appContext } from '../../../App'
import { deleteInvoice, getInvoiceById, saveInvoice } from '../InvoiceFunctions'
import { getReceiptsList } from '../../receipt/ReceiptFunctions'

export const invoiceItemControllerContext = React.createContext()

function useInvoiceItemController(props) {
  const app = useContext(appContext)
  const { invoice } = props
  const [paperSize, setPaperSize] = useState(null)

  const getInvoiceReceipt = async (invoiceId) => {
    const receipts_list = await getReceiptsList(app)
    const receipt = receipts_list.find(rec => rec.receipt_for.item_id === invoiceId)
    return receipt
  }

  useEffect(() => {
    if (paperSize) window.print()
    return (() => setPaperSize(null))
  }, [paperSize])

  const obj = {
    client: app.client,
    invoice,
    deleteInvoice,
    getInvoiceReceipt,
    getInvoiceById,
    saveInvoice,
    paperSize: [paperSize, setPaperSize]
  }
  return (obj)
}

function InvoiceItemController(props) {
  const invoiceItemController = useInvoiceItemController(props)
  return (
    <React.Fragment>
      <invoiceItemControllerContext.Provider value={invoiceItemController}>
        <InvoiceItemHeader />
        <InvoiceItemInner />
        <InvoiceItemFooter />
      </invoiceItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(InvoiceItemController)